import { Component, OnInit } from '@angular/core';
import { MainComponent } from '../main/main.component';
import { GenericCreateButtonComponent } from '../generic-components/generic-create-button/generic-create-button.component';
import { GenericSearchLabelComponent } from '../generic-components/generic-search-label/generic-search-label.component';
import { OsCorrespondance } from '../models/OsCorrespondance';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CreateOsCorrespondanceComponent } from './create-os-correspondance/create-os-correspondance.component';
import { OsCorrespondanceService } from './os-correspondance.service';
import { GenericToastrService } from '../generic-components/generic-toastr/generic-toastr.service';
import { Incident } from '../models/Incident';
import { Type } from '../models/Type';

@Component({
  selector: 'app-os-correspondance',
  imports: [
    MainComponent,
    GenericCreateButtonComponent,
    GenericSearchLabelComponent,
    GenericTableComponent,
    NgxSpinnerComponent,
  ],
  templateUrl: './os-correspondance.component.html',
  styleUrl: './os-correspondance.component.css',
})
export class OsCorrespondanceComponent implements OnInit {
  listOsCorrespondance: OsCorrespondance[] = [];
  listIncidentOsCorrespondance: Incident[] = [];

  pageInformations: PageInformations = new PageInformations();

  pageIncidentInformations: PageInformations = new PageInformations();


  emitClickRow = 'update';

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'nomOs',
        libelle: 'Nom OS',
        property: 'nomOs',
        researchable: true,
      },
      {
        id: 'type',
        libelle: 'Type de device lié',
        property: 'type',
        searchOn: 'type.libelle',
        researchable: false,
      },
      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  tableIncidentConfig: TableConfig = {
    columns: [
      {
        id: 'nomOs',
        libelle: 'OS non ajouté',
        property: 'osMissing',
        researchable: true,
      },
      {
        id: 'options',
        libelle: 'Options',
        property: 'options',
        researchable: false,
      },
    ],
  };

  constructor(
    public searchService: GenericSearchService,
    public spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public osCorrespondanceService: OsCorrespondanceService,
    public toastr: GenericToastrService
  ) {}

  ngOnInit(): void {
    this.loadOsCorrespondances();
    this.loadIncidentOsCorrespondances();
  }

  loadOsCorrespondances(query?: any) {
    this.spinner.show();

    if (query == null) {
      query = 'isDeleted=FALSE';
    }
    this.searchService
      .search(
        'os',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'nomOs=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listOsCorrespondance = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  loadIncidentOsCorrespondances(query?: any) {
    this.spinner.show();

    if (query == null) {
      query = 'statutIncident.codeStatutIncident==EC;typeIncident.codeTypeIncident==COOS;isDeleted=FALSE';
    }
    this.searchService
      .search(
        'incident',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        'idIncident=asc'
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listIncidentOsCorrespondance = res.content;
          // this.pageIncidentInformations = this.searchService.updatePageInformations(
          //   this.pageInformations,
          //   res
          // );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  pageEvent(event: any) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadOsCorrespondances();
  }

  pageIncidentEvent(event: any) {
    this.pageIncidentInformations.pageIndex = event.pageIndex;
    this.pageIncidentInformations.pageSize = event.pageSize;
    this.loadOsCorrespondances();
  }

  createButtonClicked() {
    const dialogRef = this.dialog.open(CreateOsCorrespondanceComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
    });

    dialogRef.componentInstance.createOsCorrespondanceEmit.subscribe(
      (event) => {
        debugger
        this.spinner.show();
        this.osCorrespondanceService.createOsCorrespondance(event).subscribe(
          (result) => {
            this.toastr.openSnackBarSuccess(
              'OS Correspondance créée avec succés'
            );
            this.loadOsCorrespondances();
            this.spinner.hide();
          },
          (error) => {
            this.spinner.hide();
            this.toastr.openSnackBarProblem(error.error.message);
          }
        );
      }
    );
  }

  updateOsCorrespondance(event: any) {
    const dialogRef = this.dialog.open(CreateOsCorrespondanceComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        osCorrespondance: event,
        searchService: this.searchService,
      },
    });

    dialogRef.componentInstance.updateOsCorrespondanceEmit.subscribe((event) => {
      debugger
      this.spinner.show();
      this.osCorrespondanceService.updateOsCorrespondance(event).subscribe(
        (result) => {
          this.loadOsCorrespondances();
          this.spinner.hide();

          this.toastr.openSnackBarSuccess(
            'Correspondance OS modifiée avec succés'
          );
        },
        (error) => {
          this.spinner.hide();

          this.toastr.openSnackBarProblem(error.error.message);
        }
      );
    });
  }

  updateIncidentOsCorrespondance(event: any){
    let osCorrespondance: OsCorrespondance = new OsCorrespondance();
    osCorrespondance.isDeleted = false;
    osCorrespondance.idOsCorrespondance = 0;
    osCorrespondance.nomOs = event.osMissing;
    osCorrespondance.type = new Type();
    const dialogRef = this.dialog.open(CreateOsCorrespondanceComponent, {
      disableClose: true,
      width: '50%',
      backdropClass: 'blurred-backdrop',
      data: {
        osCorrespondance: osCorrespondance,
        searchService: this.searchService,
      },
    });
  }

  deleteOsCorrespondance(event: any) {
    this.spinner.show();
    this.osCorrespondanceService.deleteOsCorrespondance(event).subscribe(result => {
      this.spinner.hide();
      this.loadOsCorrespondances();
      this.toastr.openSnackBarSuccess(
        'Correspondance OS supprimée avec succés'
      );
    }, error => {
      this.spinner.hide();
      this.toastr.openSnackBarProblem("Un problème est survenu lors de la suppression de l'OS correspondance");
    })
  }
}
